module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-mostpopular-5-975cbc5815041f0cbe0beb3814ffefa9.webp";